/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nutrtiontags.reducer';

export const NutrtiontagsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nutrtiontagsEntity = useAppSelector(state => state.nutrtiontags.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nutrtiontagsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nutrtiontags.detail.title">Nutrtiontags</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nutrtiontags.id">Id</Translate>
            </span>
          </dt>
          <dd>{nutrtiontagsEntity.id}</dd>
          <dt>
            <span id="tag">
              <Translate contentKey="tinyMedicRestApp.nutrtiontags.tag">Tag</Translate>
            </span>
          </dt>
          <dd>{nutrtiontagsEntity.tag}</dd>
          <dt>
            <span id="tmType">
              <Translate contentKey="tinyMedicRestApp.nutrtiontags.tmType">Tm Type</Translate>
            </span>
          </dt>
          <dd>{nutrtiontagsEntity.tmType}</dd>
        </dl>
        <Button tag={Link} to="/nutrtiontags" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nutrtiontags/${nutrtiontagsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NutrtiontagsDetail;
